import React from 'react';

import { RenderHtml } from '@blockworks/ui/legacy';

const EtfPageWhatIs = (props: { pageContent: string }) => {
    return (
        <RenderHtml
            className="prose prose-purple max-w-none prose-p:text-justify prose-p:mt-0 prose-p:mb-6 prose-h2:text-xl prose-headings:scroll-mt-28 prose-headings:font-normal lg:prose-headings:scroll-mt-[8.5rem] prose-lead:text-purple-500 prose-a:font-base prose-a:border-none prose-a:hover:border-none prose-a:underline prose-pre:rounded-xl prose-pre:bg-purple-900 prose-pre:shadow-lg"
            html={props.pageContent}
        />
    );
};

export default EtfPageWhatIs;
